import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, OnDestroy} from '@angular/core';
import { Chart } from 'chart.js';
import { NettestService } from '../../shared/services/graphics/nettest.service';
import { NetTest } from '../../shared/models/graphics/nettest';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { Router, ActivatedRoute } from '@angular/router';
import { rsltTypeInTitle } from 'src/app/shared/functions/title';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-nettest',
  templateUrl: './nettest.component.html',
  styleUrls: ['./nettest.component.scss', '../analysis/analysis.component.scss',
    '../../../../lib/dt-toolbar/dt-toolbar.component.css',
    '../../../../lib/styles/icons.css',
    '../../../../lib/styles/context-menu.css',
    '../../../../lib/styles/list-menu.css'],
  providers: [NettestService]
})
export class NettestComponent implements OnInit, OnDestroy {
  clearAllFiltersAction: boolean = true;
  actionsMessage: string = 'Actions';
  modifyFiltersMessage: string = 'Modify filters';
  clearFiltersMessage: string = 'Clear all filters';
  isFilters: boolean = true;
  hasFilters: boolean;

  rsltType: string = "nettest";

  rsltTypeTS = '-1';
  TSSelected: number;

  AutoRefreshInfo: any;

  title: string = "NetTest Graphics";
  staticScreen = false;
  @Output() childTitleEvent = new EventEmitter();

  isLoading = true;

  interval;
  private subscriptions: Subscription[] = [];
  filterEventIDSelected = false;
  delColSelected = false;
  columnName = "VQuad_Timestamp";
  TimestampType = 1;
  constructor(private _Activatedroute: ActivatedRoute, private _router: Router, private nettestService: NettestService, private commonFilterService: CommonFilterService, private cdr: ChangeDetectorRef) {
    _Activatedroute.params.subscribe(val => {
      this.rsltType = _Activatedroute.snapshot.url[1].path;

      this.setRsltType();
    });
    this.commonFilterService.setNonFiltersScreen(this.staticScreen);

    this.commonFilterService.TSType.subscribe(res => {//TsType
      this.TimestampType = res;
      if (this.TimestampType >= 2)//
        this.TimestampType = 1;//Change VQT to VQuad Timestamp if screen doesn't belongs to VQT types nd send as TSTYpe in filtering - IMP
      this.columnName = "VQuad_Timestamp";
      if (this.TimestampType == 2) {
        this.columnName = "VQT_Timestamp";
      }
      else if (this.TimestampType == 0) {
        this.columnName = "Call_Timestamp";
      }
    });

    const _broadSublisten = this.commonFilterService.listen.subscribe(res => {
      if (res === 'onlyNetGrphInit' && !this.filterEventIDSelected)
        this.createAllBarGraphs('');
      if (this.filterEventIDSelected)
        this.filterEventIDSelected = false;
    });
    this.subscriptions.push(_broadSublisten);

    this.commonFilterService.isFilters$.subscribe(res => {
      this.isFilters = res;
    });
    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.createAllBarGraphs('');
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    const _broadSubDeleteFilter = this.commonFilterService.DeleteFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        if (res !== '') {//IMP IMP
          this.createAllBarGraphs(res);            
        }
      }
    );
    this.subscriptions.push(_broadSubDeleteFilter);

    const _broadSubAllGeneralFilter = this.commonFilterService.AllGeneralFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log('AllGeneralFilter')
        this.AllGeneralFilter = res;
        if (!this.delColSelected && !this.clearAllFiltersBool && this.AllGeneralFilter.length > 0)
          this.createAllBarGraphs('');

        //reset here
        if (this.delColSelected)
          this.delColSelected = false;
        if (this.clearAllFiltersBool)
          this.clearAllFiltersBool = false;
      }
    );
    this.subscriptions.push(_broadSubAllGeneralFilter);

    //const _broadSubGeneralDFFilter = this.commonFilterService.GeneralFilterDF.subscribe(res => {
    //  //console.log('GeneralDFFilter')
    //  this.filters = res;
    //});
    //this.subscriptions.push(_broadSubGeneralDFFilter);
    const _broadSubGeneralFilter = this.commonFilterService.GeneralFilter.subscribe(res => {
      //console.log('GeneralFilter')
      this.filters = res;
    });
    this.subscriptions.push(_broadSubGeneralFilter);

    const _broadSubEventIDFilter = this.commonFilterService.GeneralEventIDFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log('filtersWithEventID')
        //this.filterEventIDSelected = true;
        this.filtersWithEventID = res;
        //if (!this.delColSelected && !this.clearAllFiltersBool && (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0))
        //  this.createAllBarGraphs('');
      }
    );
    this.subscriptions.push(_broadSubEventIDFilter);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(this.AutoRefreshInfo);

        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);
            this.createAllBarGraphs('');
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);
    
  }

  setRsltType() {
    this.title = rsltTypeInTitle(this.rsltType);
    this.childTitleEvent.emit(this.title);
  }

  ngOnInit() {
    //this.hasFilters = this.table.dataFilter.hasFilters();
    if (this.barGraph1 != null)
      this.barGraph1.destroy();
    if (this.barGraph2 != null)
      this.barGraph2.destroy();
    //this.createAllBarGraphs();
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  parentRef(TSSelected) {
    this.TSSelected = parseInt(TSSelected);
    //this.setRsltType();
  }
  parentEventID() {
    this.createAllBarGraphs('');
  }
  parentAutoRef(AutoRefreshInfo) {
    this.TSSelected = parseInt(AutoRefreshInfo.TSSelected);
    this.AutoRefreshInfo = AutoRefreshInfo;
  }

  modifyFilter() {
    //this._router.navigate([{ outlets: { filterPopup: ['filters'], configPopup: null } }]);
    let selectedMainFilterCrieriaName = 'null';
    this.commonFilterService.mainFilter_CriteriaName.subscribe(res => selectedMainFilterCrieriaName = res);
    this._router.navigate([{ outlets: { filterPopup: ['filters', selectedMainFilterCrieriaName], configPopup: null } }]);

    /////// when calling modify search set mainfilter to initial values
    //this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
    //this.commonFilterService.setMFCustDT("");
    //this.commonFilterService.setMFTZON(0);
    ////this.commonFilterService.basicRefresh();
  }

  clearAllFiltersBool = false;
  clearAllFilters() {
    this.createAllBarGraphs('clearAllFilters');
    //this.table.sorter.sortMeta = [];
    //this.table.events.onSort();//IMP- to reset sorting sel cols to none

    //if (this.table.dataFilter.hasFilters()) {
    //  this.table.dataFilter.clear();
    //  //console.log(this.table.dataFilter.hasFilters())
    //  this.table.events.onFilter();
    //  //this.table.events.onFilterClear();
    //  this.clearFilters.emit();
    //}
  }

  barGraph1 = null;
  barGraph2 = null;
  AllGeneralFilter = [];
  genArrDel = [];
  filtersWithEventID = {};
  filters = {};
  createAllBarGraphs(delFilterColName) {
    if (delFilterColName == 'VQuad_CallID') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
    }
    else if (delFilterColName == 'clearAllFilters') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key !== this.columnName)
          delete this.filters[key];
      }
    }
    this.isLoading = true;

    let netTest: NetTest[];
    let netTestHead = "SMS SENT/RECIEVED";
    this.nettestService.getNetTestList(delFilterColName, this.AllGeneralFilter, this.filtersWithEventID, this.filters, this.TimestampType, this.columnName).then(responseList => {
      //console.log(this.barGraph1)
      if (this.barGraph1 != null)
        this.barGraph1.destroy();
      if (this.barGraph2 != null)
        this.barGraph2.destroy();

      for (var x = 1; x < 3; x++) {
        if (x == 2)
          netTestHead = "EMAIL SENT/RECIEVED";
        netTest = <NetTest[]>responseList[x - 1];

        if (netTest[0].VQuadNewTS != undefined) {
          if (netTest[0].VQuadNewTS.trim().length != 0) {
            //let currBarGraph = new Chart('dash-bar-graph11', {
            let currBarGraph = new Chart((<HTMLCanvasElement>document.getElementById('dash-bar-graph1' + x)).getContext("2d"), {
              type: 'bar',
              data: {
                labels: netTest.map(x => x.VQuadNewTS),
                datasets: [
                  {
                    backgroundColor: 'rgba(92, 107, 192, .7)',
                    borderColor: 'rgba(92, 107, 192, .7)',
                    data: netTest.map(x => x.SENDPASSED),
                    label: 'SENDPASSED',
                    fill: 'false'
                  },
                  {
                    backgroundColor: 'rgba(66, 165, 245, .7)',
                    borderColor: 'rgba(69, 39, 160, .7)',
                    data: netTest.map(x => x.SENDFAILED),
                    label: 'SENDFAILED',
                    fill: 'false'
                  },
                  {
                    backgroundColor: 'rgba(38, 166, 154, .7)',
                    borderColor: 'rgba(69, 39, 160, .7)',
                    data: netTest.map(x => x.RECEPASSED),
                    label: 'RECEPASSED',
                    fill: 'false'
                  },
                  {
                    backgroundColor: 'rgba(102, 187, 106, .7)',
                    borderColor: 'rgba(255, 99, 132)',
                    data: netTest.map(x => x.RECEFAILED),
                    label: 'RECEFAILED',
                    fill: 'false'
                  }
                ]
              },
              options: {
                responsive: true,
                legend: {
                  display: true
                },
                elements: {
                  line: {
                    tension: 0.000001
                  }
                },
                maintainAspectRatio: false,
                plugins: {
                  filler: {
                    propagate: false
                  }
                },
                title: {
                  display: true,
                  text: netTestHead
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                    }
                  }]
                }
              }
            })

            if (x == 1)
              this.barGraph1 = currBarGraph;
            else if (x == 2)
              this.barGraph2 = currBarGraph; 
          }
        }
      }

      this.hasFilters = responseList[2] <= 0 ? false : true;
    }).catch(error => {
      this.isLoading = false;
    }
    ).finally(() => {
      this.isLoading = false;
      });

    if (delFilterColName != '' && delFilterColName != 'clearAllFilters') {
      this.delColSelected = true;

      this.commonFilterService.setDeleteFilterData('');//reset if delete

      if (delFilterColName == 'VQuad_CallID') {
        this.commonFilterService.setGeneralEventIDFilterData({});
      }

      this.genArrDel = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"] != delFilterColName;
      });
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    else if (delFilterColName == 'clearAllFilters') {
      this.clearAllFiltersBool = true;

      this.commonFilterService.setClearAllFiltersData();//reset if delete
      this.commonFilterService.setGeneralFilterData(this.filters);
      this.commonFilterService.setGeneralFilterDFData(this.filters);//mainly used in main screen

      this.filtersWithEventID = {};
      this.commonFilterService.setGeneralEventIDFilterData({});

      this.genArrDel = [];
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    //this.cdr.detectChanges();
  }
}
